import { endPoint } from "constants/server/api";
import { createFetchMaster } from "../../utils/fetchFactory";
import { createSlicePrototype } from "../../utils/sliceFactory";
var getAllMstNewItemDoColSlice = createSlicePrototype({
    name: "getAllMstNewItemDoCol"
});
export var getAllMstNewItemDoCol = createFetchMaster({
    actions: getAllMstNewItemDoColSlice.actions,
    config: {
        method: "get",
        url: endPoint.MST_NEW_ITEM_DO_COL
    }
});
var _getAllMstNewItemDoColSlice_actions = getAllMstNewItemDoColSlice.actions;
export var fetchData = _getAllMstNewItemDoColSlice_actions.fetchData, fetchDataSuccess = _getAllMstNewItemDoColSlice_actions.fetchDataSuccess, fetchDataFailure = _getAllMstNewItemDoColSlice_actions.fetchDataFailure, resetState = _getAllMstNewItemDoColSlice_actions.resetState;
export default getAllMstNewItemDoColSlice.reducer;
